import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import api from '../../api';
import { extractError } from '../../api/client';
import { showError } from '../../utils/alert';
import PageHeader from '../../components/common/PageHeader';
import Loader from '../../components/common/Loader';
import StatusBadge from '../../components/common/StatusBadge';
import { formatMoney } from '../../utils/format';

export default function PayrollDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.payroll.get(id).then(({ data }) => {
      setP(data.payroll || data);
    }).catch((err) => showError('Failed to load payroll', extractError(err))).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <Loader />;
  if (!p) return null;

  const lines = p.lines || [];

  return (
    <div className="page">
      <PageHeader
        title={`Payroll — ${p.employee ? p.employee.name : p.employee_name}`}
        subtitle={`Month: ${p.month}`}
        crumbs={[{ label: 'HR', to: '/payroll' }, { label: 'Payroll', to: '/payroll' }, { label: p.employee?.name || p.employee_name }]}
        actions={<button className="btn btn-secondary" onClick={() => navigate('/payroll')}><FiArrowLeft /> Back</button>}
      />

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-icon indigo"><i className="bi bi-box-arrow-in-down" /></div><div><div className="stat-value">{formatMoney(p.gross_earnings)}</div><div className="stat-label">Gross Earnings</div></div></div>
        <div className="stat-card"><div className="stat-icon purple"><i className="bi bi-stars" /></div><div><div className="stat-value">{formatMoney(p.special_thread_amount)}</div><div className="stat-label">Special Thread</div></div></div>
        <div className="stat-card"><div className="stat-icon red"><i className="bi bi-graph-down" /></div><div><div className="stat-value">{formatMoney(p.total_deductions)}</div><div className="stat-label">Deductions</div></div></div>
        <div className="stat-card"><div className="stat-icon green"><i className="bi bi-cash-stack" /></div><div><div className="stat-value">{formatMoney(p.net_salary)}</div><div className="stat-label">Net Salary</div></div></div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="detail-grid">
            <div className="detail-item"><div className="d-label">Status</div><div className="d-value"><StatusBadge status={p.status} /></div></div>
            <div className="detail-item"><div className="d-label">Late Deduction</div><div className="d-value">{formatMoney(p.late_deduction_amount)}</div></div>
            <div className="detail-item"><div className="d-label">Advance Deduction</div><div className="d-value">{formatMoney(p.advance_deduction)}</div></div>
            <div className="detail-item"><div className="d-label">Month</div><div className="d-value">{p.month}</div></div>
            <div className="detail-item"><div className="d-label">Employee Type</div><div className="d-value">{p.employee ? p.employee.employee_type : '-'}</div></div>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 18 }}>
        <div className="card-header"><div className="card-title">Per-Machine Breakdown</div></div>
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Machine</th><th className="table-num">Stitches</th><th>Special Thread</th>
                <th className="table-num">Rate</th><th className="table-num">Amount</th>
              </tr>
            </thead>
            <tbody>
              {lines.map((l) => (
                <tr key={l.id}>
                  <td>{l.machine ? l.machine.name : l.machine_name || '-'}</td>
                  <td className="table-num">{Number(l.stitch_count).toLocaleString()}</td>
                  <td>{l.special_thread ? 'Yes' : 'No'}</td>
                  <td className="table-num">{formatMoney(l.rate)}</td>
                  <td className="table-num">{formatMoney(l.amount)}</td>
                </tr>
              ))}
              {lines.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Fixed salary employee — no machine breakdown</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}